import React, { useState } from 'react';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';

const ComprobantesCreateSectorPrimarioToggle = ({ data, onFormDataChange }) => {
  const { Metadata } = data ?? {};

  const [active, setActive] = useState(Metadata?.SectorPrimario || false);

  const toggle = () => {
    const newChange = !active;

    setActive(newChange);

    onFormDataChange({
      ...data,
      Metadata: { ...Metadata, SectorPrimario: newChange },
    });
  };

  return (
    <Row className="mt-3">
      <Col>
        <ButtonGroup>
          <Button
            variant={active ? 'primary' : 'secondary'}
            onClick={toggle}
          >
            Si
          </Button>
          <Button
            variant={!active ? 'primary' : 'secondary'}
            onClick={toggle}
          >
            No
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  );
};

export default ComprobantesCreateSectorPrimarioToggle;
